module.exports = __webpack_public_path__ + "img/icon_notknow_avatar.dddeeec6.png";